<template>
  <CModal
    class="modal__footer-empty"
    :title="title"
    centered
    :show="show"
    :close-on-backdrop="false"
    @update:show="closeModal"
  >
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">Forgot Password</span>
      </div>

      <CButtonClose @click="closeModal" />
    </template>
    <form
      class="forgot-password-form"
      autocomplete="off"
      @submit.prevent="onSubmitForm"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            v-model="formData.email"
            label="Email"
            type="email"
            required
            placeholder="Enter email"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol col="auto">
          <CButton type="submit" color="outline-primary">
            Send
          </CButton>
        </CCol>
      </CRow>
      <CRow  v-if="error">
        <CCol col="12">
          <div class="mt-1 mb-1 text-danger" v-if="error">{{ error }}</div>
        </CCol>
      </CRow>
      <CRow  v-if="success">
        <CCol col="12">
          <div class="mt-1 mb-1 text-success" v-if="success">{{ success }}</div>
        </CCol>
      </CRow>
    </form>
  </CModal>
</template>
<script>
import { modalStore } from "@/mixins/modalsMixin";
import { getUser } from "@/utils/validation/user";
import { createAuthStoreMixin, authStore } from "@/mixins/authStoreMixin";

export default {
  name: "TheForgotPasswordModal",

  mixins: [createAuthStoreMixin()],

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showForm: true,
    error: null,
    success: null,
    formData: {
      email: null
    }
  }),

  computed: {},

  methods: {
    async onSubmitForm() {
      // let toUserId = this.user?.id;
      // this.savingErrorText = "";
      // this.saving = true;
      // let formDataPhoto;
      // const isNewUser = !toUserId;
      try {
        await this[authStore.actionTypes.ACTION_FORGOT_PASSWORD]({
          email: this.formData.email
        });
        this.success = 'Email has been send Please check your email!.'
        setTimeout(() => {
          this.success = null;
          this.$router.push('/login')
        }, 3000)
      } catch (error) {
        if (error.response && error.response.status === 404 || error.response && error.response.status === 404) {
          this.error =
          error.response &&
          error.response.data &&
          error.response.data.description;
        }else{
          this.error = error.response.data
        }
        
        console.log("err", err);
      }

      this.$emit("close");
    },
    closeModal() {
      this.$store.dispatch(
        `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
        null
      );
      this.$emit("close");
    },

    onSuccess(isNewUser) {
      if (isNewUser) {
        this.$router.push({ query: "" });
      }

      this.closeModal();
    }
  }
};
</script>
